import { FatalScreenShell } from './fatal-screen-shell';

export interface OriginRejectedScreenProps {
	/** The email the kernel rejected (when present). */
	email?: string;
	/** Kernel hostname for the error message (e.g. "kernel.example.com"). */
	kernel?: string;
	/** Why the kernel rejected. */
	reason: 'email-domain' | 'origin-header';
	/** Optional mailto/url to ping the workspace admin. */
	contactUrl?: string;
	onBackToLauncher?: () => void;
}

/**
 * Rendered when the kernel closes with 4403. The message names the rejected
 * email (if available) so the user can immediately see why access was denied
 * — no silent "please try again" loops.
 */
export function OriginRejectedScreen({ email, kernel, reason, contactUrl, onBackToLauncher }: OriginRejectedScreenProps) {
	const description =
		reason === 'email-domain' ? (
			<>
				{email ? (
					<>
						Your account (<b>{email}</b>) is not permitted on {kernel ? <b>{kernel}</b> : 'this workspace'}.
					</>
				) : (
					<>Your email is not permitted on {kernel ? <b>{kernel}</b> : 'this workspace'}.</>
				)}
				<br />
				Contact your administrator to request access.
			</>
		) : (
			<>This browser's origin is not allowed by the server. If you're running a development build, ensure the Vercel or localhost URL is listed in the kernel's origin allowlist.</>
		);

	return (
		<FatalScreenShell
			iconColor="var(--khal-status-error)"
			title="Access denied"
			description={description}
			primary={
				contactUrl
					? {
							label: 'Contact support',
							onClick: () => {
								window.location.href = contactUrl;
							},
							testId: 'origin-contact',
						}
					: undefined
			}
			secondary={
				onBackToLauncher
					? {
							label: 'Back to Launcher',
							onClick: onBackToLauncher,
							testId: 'origin-back',
						}
					: undefined
			}
		/>
	);
}
